import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const Home = () => import('./components/pages/Home');
const About = () => import('./components/pages/About');
const Portfolio = () => import('./components/pages/Portfolio');
const Contact = () => import('./components/pages/Contact');

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/portfolio',
            name: 'Portfolio',
            component: Portfolio
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        }
    ],
    scrollBehavior () {
        return { x: 0, y: 0 };
    }
});

const beforeEach = (to, from, next) => {
    const addBodyClass = () => {
        document.querySelector('body').className = to.name.toLowerCase();
    }

    addBodyClass();
    
    next();
}

router.beforeEach(beforeEach);

export default router;
